import React from "react";
import { UserProductPurchasingData } from "../ProductDetailPageResult";

interface Props {
  userProductPurchasingData: UserProductPurchasingData;
}

const UserProductPurchasingHistoryBanners = ({
  userProductPurchasingData,
}: Props) => {
  const {
    activeAutoReorderId,
    hasMultipleAutoReorders,
    nextAutoReorderDateFormatted,
    previouslyPurchasedDateFormatted,
    previouslyPurchasedOrderNumber,
  } = userProductPurchasingData;

  const autoReorderLink = hasMultipleAutoReorders
    ? "/myaccount:autoreorder/"
    : `/myaccount:autoreorder/detail/r/${activeAutoReorderId}`;

  const autoReorderMessage = hasMultipleAutoReorders ? (
    <p className="alert alert-info lastPurchased reorder">
      This product is set up with multiple auto reorders.
      <br /> Click here to view your auto reorders.
    </p>
  ) : (
    <p className="alert alert-info lastPurchased reorder">
      This item will be auto reordered on
      <br />
      <strong>{nextAutoReorderDateFormatted}</strong>
    </p>
  );

  return (
    <>
      {previouslyPurchasedOrderNumber > 0 && (
        <a
          href={`/myaccount/orders/details/${previouslyPurchasedOrderNumber}`}
          data-testid="last-purchased-banner"
        >
          <p className="alert alert-info lastPurchased">
            You last purchased this on
            <br />
            <strong>{previouslyPurchasedDateFormatted}</strong>
          </p>
        </a>
      )}
      {activeAutoReorderId > 0 && (
        <a href={autoReorderLink} data-testid="auto-reorder-banner">
          {autoReorderMessage}
        </a>
      )}
    </>
  );
};

export default UserProductPurchasingHistoryBanners;
